export default "__VITE_ASSET__Nb$8ud_p__"